module.exports = __webpack_public_path__ + "static/media/FavaRajada.04a62b09.png";